import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_4 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_5 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION", -1)
const _hoisted_7 = { class: "tw-px-4" }
const _hoisted_8 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_9 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE", -1)
const _hoisted_11 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_14 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT", -1)
const _hoisted_16 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_17 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_18 = {
  key: 0,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_20 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT", -1)
const _hoisted_22 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM", -1)
const _hoisted_27 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_30 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_32 = {
  key: 0,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_33 = {
  key: 1,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_36 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS", -1)
const _hoisted_38 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_41 = {
  key: 1,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, "PMI ", -1)
const _hoisted_43 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_46 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_48 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_51 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_53 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_56 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_58 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_61 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_63 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_66 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_68 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_71 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_73 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_76 = { class: "tw-flex tw-justify-center" }
const _hoisted_77 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_78 = { class: "tw-flex tw-justify-end" }
const _hoisted_79 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL ESTIMATED MONTHLY PAYMENT $ ", -1)
const _hoisted_81 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import axios from 'axios';
import { ref, computed, toRefs } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";

//COMPONENTS
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";
import MLOforeignResidential from '@/components/admin/Residential/MLO/MLOforeignResidential.vue';

import { useToast } from "@/composables/useToast";
import SheetTotalFinancing from '../economicSheet/SheetTotalFinancing.vue';
import SheetForeignTotalFinancing from '../economicSheet/SheetForeignTotalFinancing.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TotalFinancingMonthlyPayment',
  props: {
  foreign: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const toast = useToast();

//PROPS 

const { foreign }: any = toRefs(props)


//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const userSession = ref(null)
const selectedMLO = ref(null)
const selectedCompanyTitle = ref({ data: null })
const selectedInspector = ref({ data: null })
const customer = ref({
  name: '',
  phone: '',
  email: ''
})
const financialInformation = ref({
  pmi: 0,
  mortgage: 0,
  propertyPrice: 0,
  monthlyBudget: 0,
  downPayment: 0,
  propertyPriceQuantity: 0,
  monthlyPayment: 0,
  propertyTaxes: 0,
  stateTaxes: 0,
  propertyInsurance: 0,
  propertyFloodInsurance: 0,
  otherMontlhyPayment: 0,
  association: 0,
  totalMonthly: 0,
  sortOut: 0,
})

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

// GET TAXES FROM REALTOR FORM
const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    if (response.data.averageTaxesAndInsurance) {
      financialInformation.value.propertyTaxes = response.data.averageTaxesAndInsurance.property_taxes
      financialInformation.value.stateTaxes = response.data.averageTaxesAndInsurance.federal_taxes
      financialInformation.value.propertyInsurance = response.data.averageTaxesAndInsurance.property_insurance
      financialInformation.value.propertyFloodInsurance = response.data.averageTaxesAndInsurance.property_flood_insurance
    }
  }
  loading.value = false;
};
getRealtorForm();

const pmi = computed(() => {
  let result = 0
  if (selectedMLO.value !== null) {
    const percentage = financialInformation.value.downPayment / financialInformation.value.propertyPrice
    const percentageTwo = parseFloat(percentage.toFixed(2))
    const valueMinimunDown = selectedMLO.value.minimumDownPayment / 100
    if (percentageTwo < parseFloat(valueMinimunDown.toFixed(2))) {
      result = ((selectedMLO.value.PMI / 100) * loanAmount.value) / 12
    }
  }
  return result !== 0 ? parseFloat((result).toFixed(2)) : result
})

const loanAmount = computed(() => {
  let result = financialInformation.value.propertyPrice - financialInformation.value.downPayment
  return parseFloat(result.toFixed(2))
})

const PriceDownpayment = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0 && selectedMLO.value !== null && !foreign.value) {
    result = financialInformation.value.propertyPrice * (selectedMLO.value.minimumDownPayment / 100)
  }
  if (financialInformation.value.propertyPrice !== 0 && selectedMLO.value !== null && foreign.value) {
    result = financialInformation.value.propertyPrice * (selectedMLO.value.down_payment / 100)
  }
  return parseFloat(result.toFixed(0))
})

const propertyTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const federalTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.stateTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const propertyInsurance = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyInsurance / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const propertyFloodInsurance = computed(() => {
  let result = 0
  if (financialInformation.value.propertyFloodInsurance !== 0) {
    result = (financialInformation.value.propertyFloodInsurance * financialInformation.value.propertyPrice / 12) / 100
  }
  return parseFloat(result.toFixed(0))
})

const monthlyPayment = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null && !foreign.value) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    const interestRateRatio = (interest_rate / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest
    console.log(interestRateRatio);
  }
  if (selectedMLO.value !== null && foreign.value) {
    interest_rate = parseFloat(selectedMLO.value.interest_rate)
    const interestRateRatio = (interest_rate / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest

  }
  return parseFloat(result.toFixed(2))
})

const totalMonthly = computed(() => {
  console.log("total monthly:", monthlyPayment.value)
  let result = 0
  if (financialInformation.value.association !== null) {
    if (foreign.value) {
      result = monthlyPayment.value + propertyTaxes.value + federalTaxes.value + propertyInsurance.value + financialInformation.value.association + financialInformation.value.otherMontlhyPayment + propertyFloodInsurance.value
    } else {
      result = monthlyPayment.value + propertyTaxes.value + federalTaxes.value + propertyInsurance.value + financialInformation.value.association + financialInformation.value.otherMontlhyPayment + propertyFloodInsurance.value + pmi.value
    }
  }
  return parseFloat(result.toFixed(2))
})

const getData = async () => {
  loading.value = true;
}

const submitScenario = async () => {
  loading.value = true;
  if (!foreign.value) {
    const response = await axios(`${url}realtor-total-financing`, {
      method: "POST",
      data: {
        realtorTotalFinancing: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "TOTAL FINANCING",
          propertyPrice: financialInformation.value.propertyPrice,
          downPayment: financialInformation.value.downPayment,
          loanAmount: loanAmount.value,
          loanProgram: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interestRate,
          loanYears: selectedMLO.value.filters.year,
          pmi: pmi.value,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: financialInformation.value.association,
          otherMonthlyPayment: financialInformation.value.otherMontlhyPayment,
          totalMonthly: totalMonthly.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "TOTAL FINANCING",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
        mloSelected: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "TOTAL FINANCING",
          name: selectedMLO.value.realtorMLOData.name,
          lastname: selectedMLO.value.realtorMLOData.lastname,
          phone: selectedMLO.value.realtorMLOData.phone,
          email: selectedMLO.value.realtorMLOData.email,
          program: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interestRate,
          minimumDownPayment: selectedMLO.value.minimumDownPayment,
          pmi: selectedMLO.value.PMI,
          backEndRatio: selectedMLO.value.backEndRatio,
          maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
          client_name: customer.value.name,
          client_email: customer.value.email
        },
      }
    });

    if (!response.data.error) {
      loading.value = false;
      getData()
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } else {
    const response = await axios(`${url}realtor-total-financing`, {
      method: "POST",
      data: {
        realtorTotalFinancing: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN TOTAL FINANCING",
          propertyPrice: financialInformation.value.propertyPrice,
          downPayment: financialInformation.value.downPayment,
          loanAmount: loanAmount.value,
          loanProgram: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interest_rate,
          loanYears: selectedMLO.value.filters.year,
          pmi: pmi.value,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: financialInformation.value.association,
          otherMonthlyPayment: financialInformation.value.otherMontlhyPayment,
          totalMonthly: totalMonthly.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN TOTAL FINANCING",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
        mloSelected: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN TOTAL FINANCING",
          name: selectedMLO.value.realtorMLOData.name,
          lastname: selectedMLO.value.realtorMLOData.lastname,
          phone: selectedMLO.value.realtorMLOData.phone,
          email: selectedMLO.value.realtorMLOData.email,
          program: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interest_rate,
          minimumDownPayment: selectedMLO.value.down_payment,
          pmi: selectedMLO.value.PMI,
          backEndRatio: selectedMLO.value.backEndRatio,
          maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
          client_name: customer.value.name,
          client_email: customer.value.email
        },
      }
    });
    if (!response.data.error) {
      loading.value = false;
      getData()
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(foreign))
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial",
          helpVideo: "https://www.realtortools.org/media/VideoTotalFinancialMonthly.mp4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (!_unref(foreign))
          ? (_openBlock(), _createBlock(ResidentialView, {
              key: 0,
              header: false
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!_unref(foreign))
          ? (_openBlock(), _createBlock(SheetTotalFinancing, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(foreign))
          ? (_openBlock(), _createBlock(SheetForeignTotalFinancing, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(FindA, {
          userSession: userSession.value,
          usingCompanyTitle: selectedCompanyTitle.value,
          usingInspector: selectedInspector.value
        }, null, 8, ["userSession", "usingCompanyTitle", "usingInspector"]),
        _createElementVNode("div", _hoisted_4, [
          (!_unref(foreign))
            ? (_openBlock(), _createBlock(MLO, {
                key: 0,
                title: "TOTAL MONTHLY FINANCING PAYMENT",
                userSession: userSession.value,
                usingMLO: selectedMLO.value,
                "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
                customer: customer.value
              }, null, 8, ["userSession", "usingMLO", "customer"]))
            : _createCommentVNode("", true),
          (_unref(foreign))
            ? (_openBlock(), _createBlock(MLOforeignResidential, {
                key: 1,
                title: "TOTAL MONTHLY FINANCING PAYMENT",
                userSession: userSession.value,
                usingMLO: selectedMLO.value,
                "onUpdate:usingMLO": _cache[1] || (_cache[1] = ($event: any) => ((selectedMLO).value = $event)),
                customer: customer.value
              }, null, 8, ["userSession", "usingMLO", "customer"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "propertyPriceTotalFinancial",
                        value: financialInformation.value.propertyPrice,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((financialInformation.value.propertyPrice) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _createElementVNode("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "downPaymentTotalFinancial",
                        value: financialInformation.value.downPayment,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((financialInformation.value.downPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "downPayment",
                        value: PriceDownpayment.value,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((PriceDownpayment).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: false,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    (!_unref(foreign))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.minimumDownPayment
                          : "") + " % ", 1))
                      : _createCommentVNode("", true),
                    (_unref(foreign))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(selectedMLO.value !== null
                          ? selectedMLO.value.down_payment
                          : "") + " % ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("tr", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("td", _hoisted_22, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "loanAmount",
                        value: loanAmount.value,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((loanAmount).value = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  (!_unref(foreign))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("td", _hoisted_27, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.filters.program.toUpperCase() : ''), 1),
                        _hoisted_28,
                        _hoisted_29
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", _hoisted_30, [
                    _hoisted_31,
                    (!_unref(foreign))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.interestRate : '') + "% ", 1))
                      : _createCommentVNode("", true),
                    (_unref(foreign))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.interest_rate : '') + "% ", 1))
                      : _createCommentVNode("", true),
                    _hoisted_34,
                    _hoisted_35
                  ]),
                  _createElementVNode("tr", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("td", _hoisted_38, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.filters.year : ''), 1),
                    _hoisted_39,
                    _hoisted_40
                  ]),
                  (!_unref(foreign))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("td", _hoisted_43, " $" + _toDisplayString(pmi.value !== null ? Math.round(pmi.value).toLocaleString() : ""), 1),
                        _hoisted_44,
                        _hoisted_45
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("td", _hoisted_48, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: propertyTaxes.value,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((propertyTaxes).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_49,
                    _hoisted_50
                  ]),
                  _createElementVNode("tr", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("td", _hoisted_53, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: propertyInsurance.value,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((propertyInsurance).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_54,
                    _hoisted_55
                  ]),
                  _createElementVNode("tr", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("td", _hoisted_58, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "monthlypayment",
                        value: federalTaxes.value,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((federalTaxes).value = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_59,
                    _hoisted_60
                  ]),
                  _createElementVNode("tr", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("td", _hoisted_63, " $ " + _toDisplayString(propertyFloodInsurance.value), 1),
                    _hoisted_64,
                    _hoisted_65
                  ]),
                  _createElementVNode("tr", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("td", _hoisted_68, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "association",
                        value: financialInformation.value.association,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((financialInformation.value.association) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_69,
                    _hoisted_70
                  ]),
                  _createElementVNode("tr", _hoisted_71, [
                    _hoisted_72,
                    _createElementVNode("td", _hoisted_73, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "otherMontlhyPayment",
                        value: financialInformation.value.otherMontlhyPayment,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((financialInformation.value.otherMontlhyPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ]),
                    _hoisted_74,
                    _hoisted_75
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createVNode(_unref(VueNumberFormat), {
                    id: "association",
                    value: totalMonthly.value,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((totalMonthly).value = $event)),
                    options: {
                    precision: 0,
                    prefix: '$ ',
                    thousand: ',',
                    acceptNegative: false,
                    isInteger: false,
                    decimal: '.',
                  },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (submitScenario())),
              class: "tw-bg-[#78c18a] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, "SAVE & REGISTER")
          ])
        ])
      ])
    ])
  ]))
}
}

})